import { Swiper } from "swiper/bundle";
import {Fancybox} from "@fancyapps/ui";

export default {
    init: function () {
        // Wait for DOM to be fully ready
        if (document.readyState === "complete" || document.readyState === "interactive") {
            this.initSwipers();
        } else {
            document.addEventListener("DOMContentLoaded", () => this.initSwipers());
        }
    },

    initSwipers: function() {
        // Check for Swiper constructor
        if (typeof Swiper !== 'function') {
            console.error('Swiper not loaded properly');
            return;
        }

        // Initialize each carousel type if it exists
        this.initFeedbackCarousel();
        this.initImagesCarousel();
        this.initImagesCarouselSmall();
        this.initOtherProjectsCarousel();
        this.initOtherServicesCarousel();
    },

    initFeedbackCarousel: function() {
        const elements = document.querySelectorAll('.feedback-carousel');
        if (!elements.length) return;

        elements.forEach(element => {
            new Swiper(element, {
                slidesPerView: '1',
                spaceBetween: 30,
                centeredSlides: true,
                loop: true,
                autoplay: {
                    delay: 5000,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }
            });
        });
    },

    initImagesCarousel: function() {
        const elements = document.querySelectorAll('.images-carousel');
        if (!elements.length) return;

        elements.forEach(element => {
            new Swiper(element, {
                slidesPerView: '1',
                spaceBetween: 30,
                centeredSlides: false,
                loop: true,
                lazyPreloadPrevNext: 2,
                autoplay: {
                    delay: 5000,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }
            });
        });
    },

    initImagesCarouselSmall: function() {
        const elements = document.querySelectorAll('.images-carousel-small');
        if (!elements.length) return;

        elements.forEach(element => {
            new Swiper(element, {
                slidesPerView: 'auto',
                spaceBetween: 15,
                centeredSlides: true,
                loop: true,
                loopedSlides: 2,
                lazyPreloadPrevNext: 2,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Previous slide',
                    nextSlideMessage: 'Next slide',
                    firstSlideMessage: 'This is the first slide',
                    lastSlideMessage: 'This is the last slide',
                    paginationBulletMessage: 'Go to slide {{index}}'
                }
            });
        });
    },

    initOtherProjectsCarousel: function() {
        const elements = document.querySelectorAll('.projects-carousel');
        if (!elements.length) return;

        elements.forEach(element => {
            new Swiper(element, {
                slidesPerView: '1',
                spaceBetween: 30,
                centeredSlides: true,
                loop: true,
                loopedSlides: 2,
                lazyPreloadPrevNext: 2,
                autoplay: {
                    delay: 5000,
                },
                breakpoints: {
                    // when window width is >= 640px
                    640: {
                        slidesPerView: '2',
                    },

                    // when window width is >= 640px
                    992: {
                        slidesPerView: '3',
                    },
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }
            });
        });
    },

    initOtherServicesCarousel: function() {
        const elements = document.querySelectorAll('.services-carousel');
        if (!elements.length) return;

        elements.forEach(element => {
            new Swiper(element, {
                slidesPerView: '1',
                spaceBetween: 30,
                centeredSlides: true,
                loop: true,
                loopedSlides: 2,
                lazyPreloadPrevNext: 2,
                autoplay: {
                    delay: 5000,
                },
                breakpoints: {
                    // when window width is >= 640px
                    640: {
                        slidesPerView: '2',
                    },
                    1200: {
                        slidesPerView: '3',
                    },
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }
            });
        });
    },
};
